import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faArrowDownToBracket } from "@fortawesome/pro-light-svg-icons"
import { RemesaReadingFilteredDtoProps } from "api/DTOs/RemesaReadingFilteredDto"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { RemesaColoredNumber } from "../components/RemesaColoredNumber"
import { RemesaTipo } from "../components/RemesaTipo"

export const TABLE_REMESAS_COLUMNS = (
  t: TFunction,
  handleDownloadRemesa: (rowData: RemesaReadingFilteredDtoProps) => void
) => {
  const columns = [
    {
      key: "fecha",
      header: `${t("remesas.tab.headerDate")}`,
      field: "fecha",
      style: { width: "10%" },
      body: ({ fecha }: RemesaReadingFilteredDtoProps) =>
        fecha ? frontendDateFormat(new Date(fecha)) : "",
      sortable: true,
      sortField: "FechaVencimiento",
    },
    {
      key: "tipo",
      header: `${t("remesas.tab.headerType")}`,
      field: "tipo",
      style: { width: "10%" },
      body: ({ tipo }: RemesaReadingFilteredDtoProps) => RemesaTipo(t, tipo),
      sortable: true,
      sortField: "tipo",
    },
    {
      key: "concepto",
      header: `${t("remesas.tab.headerConcept")}`,
      style: { width: "35%" },
      field: "concepto",
      sortable: true,
      sortField: "concepto",
    },
    {
      key: "iban",
      header: `${t("remesas.tab.headerBank")}`,
      field: "iban",
      body: ({ iban }: RemesaReadingFilteredDtoProps) => iban ?? "-",
      style: { width: "15%" },
    },
    {
      key: "numeroMovimientos",
      header: `${t("remesas.tab.headerMov")}`,
      field: "numeroMovimientos",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      style: { width: "10%" },
    },
    {
      key: "importe",
      header: `${t("remesas.tab.headerTax")}`,
      field: "importe",
      style: { width: "10%" },
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      className: "!tw-font-medium",
      body: ({ tipo, importe }: RemesaReadingFilteredDtoProps) =>
        importe ? RemesaColoredNumber({ type: tipo, number: importe }) : null,
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: RemesaReadingFilteredDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            position='right'
            id={rowData.id}
            items={[
              {
                title: `${t("remesas.tab.downloadSepa")}`,
                hasRedirect: true,
                action: () => {
                  handleDownloadRemesa(rowData)
                },
                icon: faArrowDownToBracket,
              },
            ]}
          />
        )
      },
    },
  ]
  return columns
}
